<template>
    <q-header>
        <div class="header-wrap">
            <div class="header-wrap-inner">
                <div class="logo">
                    <router-link to="/">
                        <img alt="CMFA logo" src="@/assets/logo.svg" />
                    </router-link>
                </div>
                <div class="nav-wrap">
                    <div class="nav-main">
                        <router-link to="/areas">
                            {{ $tc('general.training_areas_short', 2) }}
                        </router-link>
                        <router-link to="/partners">
                            {{ $tc('general.partners', 2) }}
                        </router-link>
                        <router-link to="/classes">
                            {{ $t('general.calendar') }}
                        </router-link>
                        <router-link
                            to="#"
                            :class="{ 'router-link-active': aboutMenu }"
                        >
                            {{ $t('general.about_us') }}
                            <q-icon
                                name="expand_more"
                                style="margin-top: -5px; margin-left: -5px"
                                size="26px"
                            ></q-icon>
                            <q-menu
                                v-model="aboutMenu"
                                square
                                dark
                                :offset="[0, 10]"
                                content-style="text-transform:uppercase"
                            >
                                <q-list>
                                    <q-item
                                        v-close-popup
                                        to="/about"
                                        clickable
                                        exact
                                    >
                                        <q-item-section>{{
                                            $t('general.about_cfma')
                                        }}</q-item-section>
                                    </q-item>
                                    <q-item
                                        v-close-popup
                                        to="/news"
                                        clickable
                                        exact
                                    >
                                        <q-item-section>{{
                                            $t('general.news')
                                        }}</q-item-section>
                                    </q-item>
                                    <q-item
                                        v-close-popup
                                        to="/about/history"
                                        clickable
                                    >
                                        <q-item-section>{{
                                            $t('general.history')
                                        }}</q-item-section>
                                    </q-item>
                                    <q-item
                                        v-close-popup
                                        to="/about/team"
                                        clickable
                                    >
                                        <q-item-section
                                            >{{
                                                $t('general.team')
                                            }}
                                            CFMA</q-item-section
                                        >
                                    </q-item>
                                    <q-item
                                        v-close-popup
                                        to="/about/certificates-awards"
                                        clickable
                                    >
                                        <q-item-section
                                            >{{ $t('general.certifications') }}
                                            /
                                            {{
                                                $t('general.awards')
                                            }}</q-item-section
                                        >
                                    </q-item>
                                    <q-item
                                        v-close-popup
                                        to="/about/mission"
                                        clickable
                                    >
                                        <q-item-section>{{
                                            $t('general.mission-vision-values')
                                        }}</q-item-section>
                                    </q-item>
                                </q-list>
                            </q-menu>
                        </router-link>
                    </div>
                    <div class="nav-right">
                        <div class="search">
                            <q-input
                                v-model="search"
                                :placeholder="$tc('general.search_courses')"
                                filled
                                dense
                                color="red"
                                bg-color="grey-10"
                                :input-style="{ color: 'grey' }"
                                @keydown.enter="searchCourses"
                            >
                                <template v-slot:append>
                                    <q-icon
                                        color="primary"
                                        name="search"
                                        @click="searchCourses"
                                    />
                                </template>
                            </q-input>
                        </div>
                        <CurrencySwitcher class="q-ml-lg" />
                        <LangSwitcher class="q-ml-lg" />
                        <template v-if="!userLogged">
                            <q-btn
                                :to="{ name: 'Cart' }"
                                flat
                                round
                                color="primary"
                                icon="eva-shopping-cart-outline"
                            >
                                <q-badge
                                    v-if="cart.length > 0"
                                    color="red"
                                    floating
                                >
                                    {{ cart.length }}
                                </q-badge>
                                <q-tooltip>
                                    {{ $t('general.shopping_cart') }}
                                </q-tooltip>
                            </q-btn>
                            <router-link
                                :to="{
                                    name: 'Login',
                                    query: { redirect: $route.path },
                                }"
                                class="login"
                            >
                                {{ $t('actions.login') }}
                            </router-link>
                            <router-link to="/sign-up" class="sign-up">
                                {{ $t('actions.signup') }}
                            </router-link>
                        </template>
                        <div v-else class="right-buttons">
                            <q-btn
                                :to="{ name: 'Cart' }"
                                flat
                                round
                                color="primary"
                                icon="eva-shopping-cart-outline"
                            >
                                <q-badge
                                    v-if="cart.length > 0"
                                    color="red"
                                    floating
                                >
                                    {{ cart.length }}
                                </q-badge>
                                <q-tooltip>
                                    {{ $t('general.shopping_cart') }}
                                </q-tooltip>
                            </q-btn>
                            <q-btn
                                :to="{ name: 'Wishlist' }"
                                flat
                                round
                                color="primary"
                                icon="favorite_border"
                            >
                                <q-badge
                                    v-if="wishlistCounter > 0"
                                    color="red"
                                    floating
                                >
                                    {{ wishlistCounter }}
                                </q-badge>
                                <q-tooltip>
                                    {{ $t('general.wishlist') }}
                                </q-tooltip>
                            </q-btn>
                            <!-- <q-btn
                                :to="{ name: 'Notifications' }"
                                flat
                                round
                                color="primary"
                                icon="eva-bell-outline"
                            >
                                <q-badge
                                    v-if="notifications.length >= 1"
                                    color="red"
                                    floating
                                    >{{ notifications.length }}</q-badge
                                >
                                <q-tooltip>
                                    {{ $t('general.notifications') }}
                                </q-tooltip>
                            </q-btn> -->
                            <q-btn
                                flat
                                round
                                color="primary"
                                icon="logout"
                                @click="logout"
                            >
                                <q-tooltip>
                                    {{ $t('actions.logout') }}
                                </q-tooltip>
                            </q-btn>
                            <q-btn
                                class="profile-image"
                                round
                                :to="{ name: 'MyProfile' }"
                            >
                                <q-avatar size="50px" font-size="50px">
                                    <img
                                        class="avatar-border"
                                        :src="profileImage"
                                    />
                                </q-avatar>
                                <q-tooltip>
                                    {{ $t('general.profile') }}
                                </q-tooltip>
                            </q-btn>
                        </div>
                    </div>
                    <MobiNav />
                </div>
            </div>
        </div>
    </q-header>
</template>

<script>
import CurrencySwitcher from '@/components/CurrencySwitcher'
import LangSwitcher from '@/components/LangSwitcher'
import MobiNav from '@/components/MobiNav.vue'
import base64 from '@/local-shared/mixins/base64'
import notify from '@/local-shared/mixins/notify'
import picturesService from '@/services/pictures'
//import notificationsService from '@/services/modules/notifications'
import authenticationService from '@/services/authentication'
import encoders from '@/helpers/encoders'
import store from '@/store'
import currencies from '@/local-shared/mixins/currencies'

const loadingKeys = {
    fetchingPicture: 'fetching-picture',
    //fetchingNotifications: 'fetching-notifications',
}

export default {
    name: 'Header',

    components: {
        CurrencySwitcher,
        LangSwitcher,
        MobiNav,
    },

    mixins: [base64, notify, currencies],

    props: {
        clear: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            search: '',
            //notifications: [],
            profileImage: '',
            aboutMenu: false,
        }
    },

    computed: {
        cart() {
            return store.getters['cart/cart']
        },

        wishlistCounter() {
            return store.getters['wishlist/wishlistCount']
        },

        user() {
            let user
            if (this.isAuthenticated) {
                user = store.getters['session/user']
            }
            return user
        },

        userLogged() {
            return store.getters['session/user']
        },

        isLoading() {
            return this.isFetchingPicture || this.isFetchingNotifications
        },

        isFetchingPicture() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingPicture
            ).length
        },

        isFetchingNotifications() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingNotifications
            ).length
        },
    },

    watch: {
        user(value) {
            if (value) {
                //this.fetchNotifications()
                if (value && value.user_picture_id != null) {
                    this.fetchPicture(value.user_picture_id)
                } else {
                    this.profileImage = require('@/assets/images/user_avatar.png')
                }
            }
        },

        clear(value) {
            if (value) {
                this.search = ''
                this.$emit('search-cleared')
            }
        },
    },

    async created() {
        if (this.user && this.user.user_picture_id != null) {
            await this.fetchPicture(this.user.user_picture_id)
        } else {
            this.profileImage = require('@/assets/images/user_avatar.png')
        }
    },

    methods: {
        // async fetchNotifications() {
        //     this.loadingAdd(loadingKeys.fetchingNotifications)

        //     let parameters = {
        //         filter: {
        //             recipient_id: this.userLogged.id,
        //         },
        //     }

        //     let response = await notificationsService.retrieve(parameters)

        //     if (response.status === 200) {
        //         this.notifications = response.data.results
        //     } else {
        //         this.notifyError(response)
        //     }

        //     this.loadingRemove(loadingKeys.fetchingNotifications)
        // },

        async fetchPicture(pictureId) {
            this.loadingAdd(loadingKeys.fetchingPicture)

            let response = await picturesService.retrieveById(pictureId)

            if (response.status === 200) {
                this.profileImage = encoders.arrayBufferToBase64(response)
            } else {
                this.notifyError(response)
            }
            this.loadingRemove(loadingKeys.fetchingPicture)
        },

        async logout() {
            await authenticationService.logout()
            store.dispatch('cart/updateLibary', [])
            store.dispatch('locale/updateLocale', {})
            store.dispatch('cart/emptyCart')
            store.dispatch('wishlist/updateCount', 0)
            if (this.$route.name !== 'Home') {
                this.$router.push({ name: 'Home' })
            }
            this.initCurrency()
        },

        searchCourses() {
            this.$router
                .replace({
                    name: 'Courses',
                    query: {
                        search: this.search,
                    },
                })
                .catch(() => {})
        },
    },
}
</script>
